module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/2_2b04bd912759a3dc8c036e16cc3f66c7.png";